import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import TextInput from '@wix/da-ds/pkg/formControls/dsPresets/TextInput';
import Send from '@wix/da-ds/pkg/Icons/24x24/Send';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import LoadingIndicator from '../LoadingIndicator';
import isValidEmailAddress from '../utils/isValidEmailAddress';
import s from './VerificationEmailInput.scss';
var VerificationEmailInput = function (_a) {
    var className = _a.className, isEmailChangeInProgress = _a.isEmailChangeInProgress, isResendInProgress = _a.isResendInProgress, updateFailed = _a.updateFailed, changeEmail = _a.changeEmail;
    var t = useTranslation().t;
    var _b = useState(''), currentValue = _b[0], setCurrentValue = _b[1];
    var _c = useState(false), canSubmit = _c[0], setCanSubmit = _c[1];
    var _d = useState(false), validationFailed = _d[0], setValidationFailed = _d[1];
    var validationErrorTimeout = useRef(null);
    var isChangeInProgress = isEmailChangeInProgress || isResendInProgress;
    var hasErrors = updateFailed || validationFailed;
    var doSubmit = function () {
        if (canSubmit && !isChangeInProgress) {
            changeEmail(currentValue);
        }
    };
    var handleInputChange = function (ev) {
        var value = ev.target.value;
        var isValid = isValidEmailAddress(value);
        setCurrentValue(value);
        isValid !== canSubmit && setCanSubmit(isValid);
        // Avoid showing errors for 2 seconds until the user stops typing
        if (validationErrorTimeout.current) {
            window.clearTimeout(validationErrorTimeout.current);
            validationErrorTimeout.current = null;
        }
        if (isValid || !value) {
            setValidationFailed(false);
        }
        else {
            validationErrorTimeout.current = window.setTimeout(function () { return setValidationFailed(true); }, 2000);
        }
    };
    var handleInputKeyPress = function (ev) {
        if (!ev.defaultPrevented && ev.key === 'Enter') {
            doSubmit();
        }
    };
    var suffix = (React.createElement(PlainButtonOrLink, { onClick: doSubmit, className: cn(s['submit-btn'], !canSubmit && s['disabled']) }, isEmailChangeInProgress ? (React.createElement(LoadingIndicator, { view: "spinner", className: s['loader'] })) : (React.createElement(Send, null))));
    return (React.createElement(TextInput, { id: "verification-email-input", label: t('verification.emailInput.placeholder'), placeholder: t('verification.emailInput.placeholder'), value: currentValue, postfix: suffix, validationResult: hasErrors ? 'error' : undefined, details: hasErrors && t('verification.emailInput.error'), className: cn(className, canSubmit && s['valid']), onChange: handleInputChange, onKeyPress: handleInputKeyPress, isLabelHidden: true }));
};
export default VerificationEmailInput;
//# sourceMappingURL=VerificationEmailInput.js.map